import { render, staticRenderFns } from "./myAccountManage.vue?vue&type=template&id=1988c8dc&scoped=true"
import script from "./myAccountManage.vue?vue&type=script&lang=ts"
export * from "./myAccountManage.vue?vue&type=script&lang=ts"
import style0 from "./myAccountManage.vue?vue&type=style&index=0&id=1988c8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988c8dc",
  null
  
)

export default component.exports